import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import DatePicker from "react-datepicker"; 
import { format } from 'date-fns';
import Moment from 'react-moment';
import {Form} from 'react-bootstrap';
import FileIcon, { defaultStyles } from 'react-file-icon';
import {userGroupUrlCheck} from '../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../configs/urlConfigs';
import {LOGIN_CLIENT_GROUP, LOGIN_CREW_GROUP,ENUM_DOCUMENT_STATUS} from '../../configs/staticConfigs';
import {MSG_REQUIRED,MSG_FILE_FORMAT_ERROR,MSG_DOC_SAVE,MSG_DOC_UPDATE,MSG_DOC_DELETE,MSG_DOC_FILE_DELETE,MSG_DOC_UPLOAD,MSG_DOC_EXIST,MSG_DOC_APPROVED,MSG_DOC_REJECTED,MSG_DOC_UPLOAD_ERROR,MSG_DOC_UPDATION_ERROR,MSG_DOC_DELETE_ERROR,MSG_DOC_STATUS_UPDATION_ERROR,MSG_NOT_FOUND,MSG_DOC_ADD_ERROR} from '../../configs/msgConfigs';
import {LBL_NOT_VERIFIED,LBL_DOCUMENTS, LBL_ADD_NEW, LBL_DOCUMENT, LBL_FILE, LBL_STATUS, LBL_APPROVE, LBL_ACTIONS, LBL_APPROVED, LBL_REJECTED, LBL_REJECT, LBL_EXPIRED, LBL_DELETE, LBL_SELECT, LBL_START_DATE, LBL_END_DATE, LBL_CONFIRM_DELETE, LBL_CONFIRM_DELETE_DOCUMENT, LBL_CONFIRM_DELETE_FILE_FROM, LBL_EDIT   } from '../../configs/labelConfigs'; 

import ModalWindow from '../commons/helpers/modalWindow';
import Toast from '../commons/helpers/toast';

import * as types from '../../actions';
import {documentListAction, documentAddAction,documentEditAction, documentUpdateAction,documentDeleteAction, documentFileSaveAction, documentFileDeleteAction,skillDocumentListAction,documentStatusUpdateAction, passportFileSaveAction, visaFileSaveAction} from '../../actions/documentActions';
import {clearAction, serverTimeAction} from '../../actions/commonActions';

import {fileExtension} from '../../utils/validation';


class DocumentsBkUp extends Component {

    constructor(props){
        super()
        this.state = {
            docType:'',
            document:'0',
            startDate:'',
            defaultStartDate: '',
            endDate:'',
            activeRowId:0, 
            docId:'',
            docName:'',
            fileId:'',
            profileId:'',
            toastMessage:'',
            toastFlag:false,
            toastSuccess:true,
            dateRangeRequired:false,
            formErrors:{
                document: MSG_REQUIRED,
                // startDate:'',
                // endDate:'',
            },
        }

        this.openModal       = this.openModal.bind(this);
        this.onHandleChange  = this.onHandleChange.bind(this);
        this.onDateChange    = this.onDateChange.bind(this);
        this.onSaveFormData  = this.onSaveFormData.bind(this);
        this.onShowActionButtons = this.onShowActionButtons.bind(this);
        this.onHideActionButtons = this.onHideActionButtons.bind(this);
        this.setToasterState = this.setToasterState.bind(this); 
        this.removeDocFile   = this.removeDocFile.bind(this);  
        this.removePassportFile   = this.removePassportFile.bind(this);  

        this.modal           = React.createRef(); 
        this.modalDelete     = React.createRef(); 
        this.modalFileDelete = React.createRef();  
        this.modalPassportFileDelete = React.createRef();  
    }

    openModal=(e)=> {
        e.preventDefault();
        this.modal.current.handleOpenModal();
     } 

    onSaveFormData = (e) =>{
        e.preventDefault();   

        let data = {};
   
        let {docType,document,startDate,endDate,dateRangeRequired,formErrors} = this.state;
        
        if(document!=='0'){
            
            if(this.props.userType===LOGIN_CLIENT_GROUP){
                data = {
                    "affiliate_document": document.split('_')[1],               
                    "client_profile": this.props.clientId
                }
            }else if(this.props.userType===LOGIN_CREW_GROUP){
                if(docType==="2"){
                    data = {
                        "affiliate_document": document.split('_')[1],                   
                        "crew_profile": this.props.crewId,
                        "crew_skill":null
                    }
                }else if(docType==="3"){
                    data = {
                        "crew_skill":document.split('_')[1],                   
                        "crew_profile": this.props.crewId,
                        "affiliate_document":null
                    }
                }
                
            }  
            if(dateRangeRequired){
                if(startDate!==''){ 
                    data["valid_from"] = startDate;
                }else{
                    data["valid_from"] = null;
                }if(endDate!==''){
                    data["valid_to"]   = endDate;
                }else{
                    data["valid_to"]   = null;
                }
                    
                    // formErrors.startDate = "";
                    // formErrors.endDate = "";
                // else{                   
                //     formErrors.startDate = 
                //     startDate.length <=0 
                //     ? MSG_REQUIRED
                //     : "";
                //     formErrors.endDate = 
                //     endDate.length <=0 
                //     ? MSG_REQUIRED
                //     : "";
                // }                
            }else{
                data["valid_from"] = null;
                data["valid_to"]   = null;
            }
            // if(formErrors.startDate.length<=0 && formErrors.endDate.length<=0){
                if(this.state.docId){
                    data['docId'] = this.state.docId;
                    let docExist = [];

                    if(docType==="1"){
                        docExist = this.props.docList.filter(item => item.affiliate_document ===Number(document.split('_')[1]) && item.id!==this.state.docId);
                    }
                    else if(docType==="2"){
                        docExist = this.props.docList.filter(item => item.affiliate_document ===Number(document.split('_')[1]) && item.id!==this.state.docId);
                    }else{
                        docExist = this.props.docList.filter(item => item.crew_skill ===Number(document.split('_')[1]) && item.id!==this.state.docId);
                    }
                    if(docExist.length===0){
                        this.props.documentUpdateAction(data);
                    }else{
                        formErrors.document = MSG_DOC_EXIST;
                    }
                }else{
                    let docExist = [];
                    if(docType==="1"){
                        docExist = this.props.docList.filter(item => item.affiliate_document ===Number(document.split('_')[1]) && item.id!==this.state.docId);
                    }
                    else if(docType==="2"){
                        docExist = this.props.docList.filter(item => item.affiliate_document ===Number(document.split('_')[1]));
                    }else{
                        docExist = this.props.docList.filter(item => item.crew_skill ===Number(document.split('_')[1]));
                    }
                    if(docExist.length===0){
                        this.props.documentAddAction(data);
                    }else{
                        formErrors.document = MSG_DOC_EXIST;
                    }
                    
                }    
            // }           
            
        }else{
            formErrors.document = 
            document.length <=0 || document==='0'
            ? MSG_REQUIRED
            : "";
        }
        this.setState({formErrors});
    }

    onModalFormReset = () =>{       
        this.setState({
            document:'0',
            startDate:'',
            endDate:'',
            docId:'',
            fileId:'',
            docName:'',
            dateRangeRequired:false,
            formErrors:{
                document:MSG_REQUIRED,
                startDate:'',
                endDate:''
            }
           
        }); 
    }

    removeDocFile =(fileId,docId,name)=>{        
        this.modalFileDelete.current.handleOpenModal();
        this.setState({
            fileId:fileId,
            docId:docId,
            docName:name          
        });  
        
    }   

    removeDocFileAction = () =>{
        let fileId = this.state.fileId;
        let docId  = this.state.docId;
        let data ={
            "fileId":fileId,
            "docId":docId
        }
        this.props.documentFileDeleteAction(data);
        this.modalFileDelete.current.handleModelClose();                    
    }

    removePassportFile =(profileId)=>{        
        this.modalPassportFileDelete.current.handleOpenModal();
         this.setState({
            profileId:profileId,
        });  
    }   

    removePassportFileAction = () =>{
        let data ={
            "crew_profile": this.state.profileId,
            "action": "remove"
        }
        this.props.passportFileSaveAction(data);
        // this.props.documentFileDeleteAction(data);
        this.modalPassportFileDelete.current.handleModelClose();                    
    }

    onDateChange = (type,date) =>{
        if(type===1){
            let startDate = '';
            if(date){
                startDate = format(new Date(date), 'yyyy-MM-dd');
            }
            
            this.setState({startDate:startDate,endDate:''});
        }
        if(type===2){
            let endDate = '';
            if(date){
                endDate   = format(new Date(date), 'yyyy-MM-dd');
            }
            this.setState({endDate:endDate});
        }
    }

    onHandleChange = (e) =>{
        const {name,value}  = e.target;
        if(e.target.type=== "file"){ // document upload
            let isFileValid = true;
            if(e.target.files.length>0){
                for (let x = 0; x < e.target.files.length; x++) {
                    if(!fileExtension(e.target.files[x].name)){
                        isFileValid = false;
                    }
                }
                if(isFileValid){
                    const data  = new FormData();
                    if(this.props.userType===LOGIN_CLIENT_GROUP){
                        data.append('client_profile', this.props.clientId); 
                        data.append('certificate_type', 'document');
                        
                    }else if(this.props.userType===LOGIN_CREW_GROUP){
                        data.append('crew_profile', this.props.crewId); 
                        data.append('certificate_type', 'skill'); 
                    }
                    data.append('document_details_id', Number(e.target.id)); 
                    for (let x = 0; x < e.target.files.length; x++) {
                        data.append("files", e.target.files[x]);
                    }
                    if (e.target.id == 'passport_1'){
                        data.append("action", "add");
                        this.props.passportFileSaveAction(data);
                    }else if (e.target.id == 'visa_1'){
                        data.append("action", "add");
                        this.props.visaFileSaveAction(data);
                    } else{
                        this.props.documentFileSaveAction(data);
                    }
                }else{
                    this.setToasterState(true,MSG_FILE_FORMAT_ERROR,false); 
                }  
            }    

        }else if(e.target.type==="select-one"){
            let formErrors = this.state.formErrors;
            let docArray = [];
            let dateRequired = false;
         
            if(name==='document'){
                formErrors.document = 
                value.length <=0 || Number(value)===0
                ? MSG_REQUIRED
                : ""
            }
            if(e.target[e.target.selectedIndex].getAttribute('data-id')==="1"){
                docArray = this.props.docs;
                if(docArray.length>0){
                    const dateReqrdDoc = docArray.filter(item => item.id===Number(value.split('_')[1]));
                    if(dateReqrdDoc.length > 0){
                        dateRequired = dateReqrdDoc[0].date_range
                    }
                }
            }else if(e.target[e.target.selectedIndex].getAttribute('data-id')==="2"){
                docArray = this.props.docs.document_details;
                if(docArray.length>0){
                    const dateReqrdDoc = docArray.filter(item => item.affiliate_document_master_id ===Number(value.split('_')[1]));
    
                    dateRequired = dateReqrdDoc[0].date_range
                }
            }else if(e.target[e.target.selectedIndex].getAttribute('data-id')==="3"){
                
                docArray = this.props.docs.skill_details;
                if(docArray.length>0){
                    const dateReqrdDoc = docArray.filter(item => item.crew_skill_id ===Number(value.split('_')[1]));
                    dateRequired = dateReqrdDoc[0].affiliate_skill.date_range;
                }
            }           
            
            if(dateRequired) {
                formErrors.startDate = this.state.startDate=='' ? MSG_REQUIRED : ''; 
                formErrors.endDate   = this.state.endDate=='' ? MSG_REQUIRED : ''; 
            }
            
            this.setState({document:value,docType:e.target[e.target.selectedIndex].getAttribute('data-id'),dateRangeRequired:dateRequired,formErrors});
        }
    }

    onShowActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('docdropdown-'+rowId);
        let dropdownMenu = document.getElementById('docdropdown-menu-'+rowId);
        dropdown.classList.toggle('show');
        dropdownMenu.classList.toggle('show');      
        if(this.state.activeRowId===0){   
           this.setState({activeRowId:rowId}); 
        }else if(this.state.activeRowId===rowId){ 
           this.setState({activeRowId:0}); 
        }else if(this.state.activeRowId!==rowId){   
           dropdown     = document.getElementById('docdropdown-'+this.state.activeRowId);
           dropdownMenu = document.getElementById('docdropdown-menu-'+this.state.activeRowId);
           dropdown.classList.toggle('show');
           dropdownMenu.classList.toggle('show');
           this.setState({activeRowId:rowId}); 
        }        
        
    }    
  
    onHideActionButtons = (event, rowId) =>{
        let dropdown     = document.getElementById('docdropdown-'+rowId);
        let dropdownMenu = document.getElementById('docdropdown-menu-'+rowId);
        dropdown.classList.remove('show');
        dropdownMenu.classList.remove('show');
        this.setState({activeRowId:0});
    }   

    editBtnClick = (rowId) =>{        
        let formErrors = this.state.formErrors;
        formErrors.document = '';  
        this.setState(formErrors);
        this.modal.current.handleOpenModal();
        this.props.documentEditAction(rowId);
    }

    approveRejectDoc = (rowId,docStatus) =>{  
        let data ={
            docId:rowId,
            status:docStatus
        }              
        this.props.documentStatusUpdateAction(data);
    }   
  
    deleteBtnClick = (rowId,name) =>{
        this.setState({
           docId:rowId,
           docName:name          
        }); 
        this.modalDelete.current.handleOpenModal();
    }

    onDeleteAction = () =>{
        let docId = this.state.docId;
        this.props.documentDeleteAction(docId);
        this.modalDelete.current.handleModelClose();                    
    }

    onCloseToast = () =>{
        this.setState({toastFlag:false,toastMessage:'',toastSuccess:false});
    } 

    setToasterState(isEnabled,message,isSucces,isAutoHide=true){
        this.setState({toastFlag:isEnabled,toastMessage:message,toastSuccess:isSucces});
        if(isAutoHide){
            setTimeout(()=> {
                this.onCloseToast();
            }, 3000);
        }      
    }

    setStateUpdate(doc, status, activity,errorData,docStatus, passport_url){
        //let formErrors = this.state.formErrors; 
        if(activity===types.DOCUMENT_ADD_SUCCESS){ 
            this.modal.current.handleModelClose();
            this.setToasterState(true,MSG_DOC_SAVE,true);
            this.props.documentListAction({crew:this.props.crewId,client:this.props.clientId});
            if(this.props.callparentValidate && this.props.callparentValidate==='yes') {
                this.props.callValidate(); 
            }
        }else if(activity===types.DOCUMENT_ADD_ERROR){ 
            this.modal.current.handleModelClose(); 
            this.setToasterState(true,MSG_DOC_ADD_ERROR,false); 
            // this.setToasterState(true,JSON.stringify(errorData),false); 
        }else if(activity===types.DOCUMENT_EDIT_SUCCESS){
            this.setState({
                docId:doc.docId,
                document:doc.document,
                startDate:doc.startDate?doc.startDate:'',
                endDate:doc.endDate?doc.endDate:'',
                docType:doc.docType,
                dateRangeRequired:doc.dateRangeRequired
            });
        }else if(activity===types.DOCUMENT_UPDATE_SUCCESS){ 
            this.modal.current.handleModelClose();
            this.setToasterState(true,MSG_DOC_UPDATE,true);
            this.props.documentListAction({crew:this.props.crewId,client:this.props.clientId}); 
            this.props.callValidate();
            if(this.props.calledFrom && this.props.calledFrom==='certificates')  {
                this.props.callCertificateListAction(); 
            } 
        }else if(activity===types.DOCUMENT_UPDATE_ERROR){ 
            this.modal.current.handleModelClose();
            this.setToasterState(true,MSG_DOC_UPDATION_ERROR,false); // JSON.stringify(errorData)
        }else if(activity===types.DOCUMENT_DELETE_SUCCESS){
            this.setToasterState(true,MSG_DOC_DELETE,true); 
            this.props.documentListAction({crew:this.props.crewId,client:this.props.clientId}); 
            this.props.callValidate(); 
        }else if(activity===types.DOCUMENT_DELETE_ERROR){ 
            this.setToasterState(true,MSG_DOC_DELETE_ERROR,false);
        }else if(activity===types.DOCUMENT_FILE_SAVE_SUCCESS){ 
            this.setToasterState(true,MSG_DOC_UPLOAD,true);
            this.props.documentListAction({crew:this.props.crewId,client:this.props.clientId});
            this.props.callValidate();
            document.getElementsByName("docFile")[0].value = ""; 
        }else if(activity===types.DOCUMENT_FILE_SAVE_ERROR){ 
            this.setToasterState(true,MSG_DOC_UPLOAD_ERROR,false);
            document.getElementsByName("docFile")[0].value = "";
        }else if(activity===types.DOCUMENT_FILE_DELETE_SUCCESS){ 
            this.setToasterState(true,MSG_DOC_FILE_DELETE,true); 
            this.props.documentListAction({crew:this.props.crewId,client:this.props.clientId}); 
            this.props.callValidate();
        }else if(activity===types.DOCUMENT_FILE_DELETE_ERROR){ 
            this.setToasterState(true,MSG_DOC_DELETE_ERROR,false);
        }else if(activity===types.DOCUMENT_STATUS_UPDATE_SUCCESS){
            let msg = '';
            if(docStatus.document_status===ENUM_DOCUMENT_STATUS.VERIFIED){
                msg = MSG_DOC_APPROVED;
            }else if(docStatus.document_status===ENUM_DOCUMENT_STATUS.REJECTED){
                msg = MSG_DOC_REJECTED;
            }
            this.setToasterState(true,msg,true);
            this.props.documentListAction({crew:this.props.crewId,client:this.props.clientId});
            this.props.callValidate(); 
        }else if(activity===types.DOCUMENT_STATUS_UPDATE_ERROR){
            this.setToasterState(true,MSG_DOC_STATUS_UPDATION_ERROR,false);
        }else if (activity==types.PASSPORT_FILE_SAVE_SUCCESS){
            this.setToasterState(true,MSG_DOC_UPDATE,true);
            let newcrewData = this.props.crewData;
            newcrewData.basicInfo.passport = passport_url;
            this.setState({crewData: newcrewData});
        }
    }

    componentDidUpdate(prevProps) { 
        const { doc, status, activity,errorData,docStatus, passport_url} = this.props; 
        if(this.props.serverTimeListActivity && this.props.serverTimeListActivity !== prevProps.serverTimeListActivity){
            let arrTimeResp = this.props.serverTimeListActivity.split('~~');
            if(arrTimeResp[0]===types.SERVER_TIME_LIST_SUCCESS){
                let defaultStartDate = new Date(this.props.serverTimeList.current_date+"T00:00:00");
                this.setState({defaultStartDate:defaultStartDate})
            }
        }
        if((this.props.crewId > 0 && this.props.crewId!==prevProps.crewId) || (this.props.clientId > 0 && this.props.clientId!==prevProps.clientId)){
            this.props.documentListAction({crew:this.props.crewId,client:this.props.clientId}); 
            // VARIABLES document AND client_id ARE PASSED ON THE REQUEST OF SERVER TEAM ON 24Nov2020 
            let document = this.props.document ? this.props.document : 0; 
            let client_id = this.props.client_id ? this.props.client_id : 0; 
            this.props.skillDocumentListAction({crew:this.props.crewId,client:this.props.clientId,document:document,client_id:client_id})
        }

        if (activity !== prevProps.activity) {
            this.setStateUpdate(doc, status, activity,errorData,docStatus, passport_url);
            this.props.clearAction();
        }
    }

    componentDidMount() {
        this.props.serverTimeAction();   
        if(this.props.crewId||this.props.clientId){
            this.props.documentListAction({crew:this.props.crewId,client:this.props.clientId}); 
            // VARIABLES document AND client_id ARE PASSED ON THE REQUEST OF SERVER TEAM ON 24Nov2020 
            let document = this.props.document ? this.props.document : 0; 
            let client_id = this.props.client_id ? this.props.client_id : 0; 
            this.props.skillDocumentListAction({crew:this.props.crewId,client:this.props.clientId,document:document,client_id:client_id})
        }
    }
    
    render(){
        const {docs,docList, crewData} = this.props;
        const {document,startDate,endDate,toastMessage,toastFlag,toastSuccess, dateRangeRequired,formErrors} = this.state;

        let isSuperAdmin = this.props.isSuperAdmin ? this.props.isSuperAdmin : false; 

        let selectedStartDate = '';
        let selectedEndDate = '';

        if(startDate!==''){
            if(typeof startDate === 'string'){
                selectedStartDate = new Date(startDate+ " 00:00:00");
            }else{
               selectedStartDate = new Date(startDate); 
            }
            
        }
        if(endDate!==''){
            if(typeof endDate === 'string'){
                selectedEndDate = new Date(endDate+ " 00:00:00");
            }else{
                selectedEndDate = new Date(endDate);
            }
        }


        let docDetail = [];
        let skillDetail = [];
        if(docs.document_details!==undefined){
            docDetail = docs.document_details
        }
        if(docs.skill_details!==undefined){
            skillDetail = docs.skill_details
        }
        let companyName = ''; 
        if(this.props.hasOwnProperty('showNameInHeader')) companyName = this.props.showNameInHeader; 

        let userGroupData = userGroupUrlCheck(window.location);
        let userGroup = '';
        let isClientPage = false;
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }   
        if(userGroup===LOGIN_CLIENT_GROUP){
            isClientPage = true;
        }
        let passportext ='';
        if (crewData && crewData.basicInfo.passport){
            passportext = crewData.basicInfo.passport.substr(crewData.basicInfo.passport.lastIndexOf('.') + 1);
        }

        return(
            <React.Fragment>
                <Toast toastDescription={toastMessage} toastFlag={toastFlag} toastSuccess={toastSuccess} closeToast={this.onCloseToast} />
                <div className="col-md-12">
                <Form autoComplete="off" className="document" encType="multipart/form-data"> 
                    <Form.Group className="col-md-12">
                        <div className="box margin-top-12">
                            <div className="box-content">
                                <div className="table-responsive">
                                {crewData && <div>
                                <div className="detail-head border-bottom pb-2 padding-top-7">Passport & Visa</div>
                                    <table id="data-table" className="table" style={{width:"100%"}}>
                                        <thead>
                                            <tr>
                                                <th>{LBL_DOCUMENT}</th>
                                                <th className="text-center">{LBL_START_DATE}</th>
                                                <th className="text-center">{LBL_END_DATE}</th>
                                                <th className="text-center">{LBL_FILE}</th>
                                            </tr>
                                        </thead>                                    
                                        <tbody> 
                                            <tr >
                                                <td>
                                                    Passport
                                                </td>
                                                <td className="text-center">
                                                    
                                                </td>
                                                <td className="text-center">
                                                </td>
                                                <td className="text-center">
                                                    { crewData.basicInfo.passport && 
                                                        <div className="file-icon">
                                                            <a href={crewData.basicInfo.passport} target="_blank" rel="noopener noreferrer" style={{display:"inline"}}>
                                                            <FileIcon extension={passportext} fold={true} 
                                                            radius={3} color="whitesmoke" {...defaultStyles[passportext]}/>
                                                            </a>
                                                             {!isSuperAdmin && <span className=" remove-file" onClick=
                                                                {(e)=>this.removePassportFile(crewData.basicInfo.id)}><i className="las la-minus"></i></span>}
                                                            
                                                        </div>
                                                    }

                                                    <label htmlFor="passport_1">
                                                        <i className="las la-plus add-file" ></i>
                                                    </label>
                                                    <input type="file" id="passport_1" name="docFile" onChange={this.onHandleChange} accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.xlsx,.xls" multiple/>
                                                </td>
                                            </tr> 
                                             
                                            <tr >
                                                <td>
                                                    Visa
                                                </td>
                                                <td className="text-center">
                                                    
                                                </td>
                                                <td className="text-center">
                                                </td>
                                                <td className="text-center">
                                                    { crewData.basicInfo.visa && 
                                                        <div className="file-icon">
                                                            <a href={crewData.basicInfo.visa} target="_blank" rel="noopener noreferrer" style={{display:"inline"}}>
                                                            <FileIcon extension={passportext} fold={true} 
                                                            radius={3} color="whitesmoke" {...defaultStyles[passportext]}/>
                                                            </a>
                                                             {!isSuperAdmin && <span className=" remove-file" onClick=
                                                                {(e)=>this.removePassportFile(crewData.basicInfo.id)}><i className="las la-minus"></i></span>}
                                                            
                                                        </div>
                                                    }
                                                    <label htmlFor="visa_1">
                                                        <i className="las la-plus add-file" ></i>
                                                    </label>
                                                    <input type="file" id="visa_1" name="docFile" onChange={this.onHandleChange} accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.xlsx,.xls" multiple/>
                                                </td>
                                            </tr>                    
                                        </tbody>
                                    </table>
                                    <br/><div className="detail-head border-bottom pb-2 padding-top-7">Other Documents</div></div>
                                }
                                <div className="tab-head">
                                    {this.props.noHeaderName && this.props.noHeaderName==="yes" && <h6>&nbsp;</h6>}
                                    {!this.props.noHeaderName && <h6>{LBL_DOCUMENTS} {(companyName) && <span>{' - '+companyName}</span>}</h6>}

                                    {!isSuperAdmin && <div className="to-right">
                                        <button onClick={this.openModal} className="btn btn-primary launch-modal">{LBL_ADD_NEW}</button>
                                    </div>}
                                </div> 

                                    <table id="data-table" className="table" style={{width:"100%"}}>
                                        <thead>
                                            <tr>
                                                <th>{LBL_DOCUMENT}</th>
                                                <th className="text-center">{LBL_START_DATE}</th>
                                                <th className="text-center">{LBL_END_DATE}</th>
                                                <th className="text-center">{LBL_FILE}</th>
                                                <th className="text-center">{isClientPage ? LBL_STATUS : LBL_APPROVE}</th>
                                                <th className="text-center">{!isSuperAdmin ? LBL_ACTIONS : ''}</th>
                                            </tr>
                                        </thead>                                    
                                        <tbody> 
                                            {Array.isArray(docList) && docList.length===0 && <tr><td className="text-center" colSpan="6">{MSG_NOT_FOUND}</td></tr>}
                                            
                                            { Array.isArray(docList) && docList.map((item)  => {
                                                let documentStatus = '';
                                                let rejectLink = isSuperAdmin ? '' : <Link className="dropdown-item delete" to="#" onMouseDown={(e) => this.approveRejectDoc(item.id,ENUM_DOCUMENT_STATUS.REJECTED)}>{LBL_REJECT}</Link>;

                                                if(item.status===ENUM_DOCUMENT_STATUS.NOTVERIFIED && item.certificates.length>0){
                                                    documentStatus = (isClientPage || isSuperAdmin) ? LBL_NOT_VERIFIED : <Link to="#" onClick={(e) => this.approveRejectDoc(item.id,ENUM_DOCUMENT_STATUS.VERIFIED)}>{LBL_APPROVE}</Link>;
                                                }else if(item.status===ENUM_DOCUMENT_STATUS.VERIFIED){
                                                    documentStatus = <span>{LBL_APPROVED}</span>;
                                                }else if(item.status===ENUM_DOCUMENT_STATUS.REJECTED){
                                                    documentStatus = <span className="text-red">{LBL_REJECTED}</span>;
                                                    rejectLink = isSuperAdmin ? '' : <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.approveRejectDoc(item.id,ENUM_DOCUMENT_STATUS.VERIFIED)}>{LBL_APPROVED}</Link>;
                                                }else if(item.status===ENUM_DOCUMENT_STATUS.EXPIRED){
                                                    documentStatus = <span className="text-red">{LBL_EXPIRED}</span>;
                                                    rejectLink = '';
                                                }    
                                            return (
                                                <tr key={item.id}>
                                                    <td>
                                                        {
                                                        item.crew_skill_details===null?item.affiliate_document_details.name:item.crew_skill_details.affiliate_skill.certificate_name
                                                        }
                                                    </td>
                                                    <td className="text-center">
                                                    { (item.valid_from!==null && item.valid_from !== '') &&
                                                        <Moment format="DD/MM/YYYY ">
                                                            {item.valid_from}
                                                        </Moment>
                                                    }
                                                        
                                                    </td>
                                                    <td className="text-center">
                                                        { (item.valid_to!==null && item.valid_to !== '') &&
                                                            <Moment format="DD/MM/YYYY ">
                                                                {item.valid_to}
                                                            </Moment>
                                                        }
                                                    </td>
                                                    <td className="text-center">
                                                        {
                                                        item.certificates.map(el => {
                                                            let ext = el.file.substr(el.file.lastIndexOf('.') + 1);
                                                           
                                                            return (
                                                            <div className="file-icon" key={el.id}>
                                                                <a href={el.file} target="_blank" rel="noopener noreferrer" style={{display:"inline"}}>
                                                                <FileIcon extension={ext} fold={true} 
                                                                radius={3} color="whitesmoke" {...defaultStyles[ext]}/>
                                                                </a>
                                                                {!isSuperAdmin && <span className=" remove-file" onClick=
                                                                {(e)=>this.removeDocFile(el.id,item.id,item.crew_skill_details===null?item.affiliate_document_details.name:item.crew_skill_details.affiliate_skill.certificate_name)}><i className="las la-minus"></i></span>}
                                                            </div>
                                                            )
                                                        })
                                                        }
                                                     
                                                        {!isSuperAdmin && <> <label htmlFor={item.id}>
                                                                <i className="las la-plus add-file" ></i>
                                                            </label>
                                                            
                                                            <input type="file" id={item.id} name="docFile" onChange={this.onHandleChange} accept=".pdf,.doc,.docx,.jpeg,.jpg,.png,.xlsx,.xls" multiple/>
                                                        </>}
                                                    </td>
                                                    <td className="text-center">{documentStatus}</td>
                                                    <td className="text-center">
                                                        {!isSuperAdmin && <div className="dropdown text-center" id={'docdropdown-'+item.id}>
                                                            <button className="dropdown-toggle floatNone" type="button"
                                                                id={'dropdownMenuButton-'+item.id} data-toggle="dropdown show"
                                                                aria-haspopup="true" onClick={(e) => this.onShowActionButtons(e, item.id)}
                                                                onBlur={(e) => this.onHideActionButtons(e, item.id)}
                                                                >
                                                                <img id="test" src={require('../../'+URL_IMG+'action.png')} alt="Action" />
                                                            </button>
                                                            <div className="dropdown-menu" aria-label="doc-dropdown" id={'docdropdown-menu-'+item.id}
                                                                aria-labelledby={'dropdownMenuButton-'+item.id}>
                                                                <Link className="dropdown-item edit" to="#" onMouseDown={(e) => this.editBtnClick(item.id)}>{LBL_EDIT}</Link>
                                                                
                                                                {!isClientPage && item.certificates.length>0?rejectLink:''}
                                                    
                                                                <Link className="dropdown-item delete"
                                                                    to="#" onMouseDown={(e)=>this.deleteBtnClick(item.id,item.crew_skill_details===null?item.affiliate_document_details.name:item.crew_skill_details.affiliate_skill.certificate_name)}>{LBL_DELETE}</Link>
                                                            </div>
                                                        </div> }
                                                    </td>
                                                </tr>    
                                                
                                            )
                                            })      

                                            }                      
                                        </tbody>
                                    </table>
                                    <div className="clear-b-scroll-sector paddingTop35">&nbsp;</div>
                                    <div className="clear-b-scroll-sector paddingTop35">&nbsp;</div>
                                </div>   
                                
                                <div className="row">&nbsp;</div>                          
                            </div>   
                            {/* <div className="tab-head bottom">
                                <div className="to-right"> 
                                    <button onClick={e => this.saveFile(e)} className="btn btn-primary launch-modal">Save</button>
                                </div>
                            </div>                          */}
                        </div>
                        
                    </Form.Group>
                </Form>
                <div className="padding-top-50">&nbsp;</div>
                <div className="padding-top-50">&nbsp;</div>
                <div className="padding-top-50">&nbsp;</div>
                <div className="padding-top-50">&nbsp;</div>
                </div>

                <ModalWindow ref={this.modal} header="Document" saveFormData={ (e)=>this.onSaveFormData(e)} resetModalForm={this.onModalFormReset} type="save">
                    <Form autoComplete="off">
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group"> 
                                    <label>{LBL_DOCUMENT}</label>
                                    <div className="form-group select-input">
                                        <select onChange={this.onHandleChange} value={document || ''} id="documentType" className={formErrors.document.length >0 ? "input-error" : ''} name="document">
                                            <option value="0">{LBL_SELECT}</option>                             
                                                
                                                { (this.props.userType===LOGIN_CLIENT_GROUP && docs.length>0) && Array.isArray(docs) &&
                                                    //docs.map((item) => <option key={item.id} value={'doc_'+item.id} data-id="1">{item.name}</option>)
                                                    docs.map((item) => {
                                                        if(item.is_active===true) {
                                                            return <option key={item.id} value={'doc_'+item.id} data-id="1">{item.name}</option>
                                                        }
                                                        else {
                                                            return null; 
                                                        }
                                                    
                                                    })
                                                } 

                                                { (this.props.userType===LOGIN_CREW_GROUP) &&
                                                    <>
                                                        { (docDetail.length>0) &&
                                                          <optgroup label="Document">
                                                          {docDetail.map((item,index) => 
                                                          <option key={index} value={'doc_'+item.affiliate_document_master_id} data-id="2">{item.name}</option >)}
                                                          </optgroup> 
                                                        }
                                                        { (skillDetail.length>0) &&
                                                          <optgroup label="Skill">
                                                          {skillDetail.map((item,index) => 
                                                          <option key={index} value={'skill_'+item.crew_skill_id} data-id="3">{item.affiliate_skill.certificate_name}</option>)}
                                                          </optgroup> 
                                                        }
                                                                                                                                                                          </>
                                                }
                                        </select>
                                        {this.state.formErrors.document.length >0 && this.state.formErrors.document!==MSG_REQUIRED&& (
                                        <div className="text-red left-align text-12">{this.state.formErrors.document}</div>
                                        )} 
                                    </div>                                    
                                </div>
                            </div>                        
                        </div>
                        { (dateRangeRequired) && 
                        <div className="row">
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{LBL_START_DATE}</label>
                                    <div className="calendar-inputt doument-date ">                                    
                                        <DatePicker 
                                        selected={selectedStartDate}
                                        name="startDate"
                                        onChange={selected => this.onDateChange(1,selected)}  
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText={LBL_START_DATE}
                                        maxDate={this.state.defaultStartDate}
                                        minDate={new Date('1940/01/01')}
                                        fixedHeight                                
                                        // className={formErrors.startDate.length >0 ? "input-error" : ''}
                                        />
                                    </div>
                                </div>
                            </div> 
                        
                            <div className="col-md-6">
                                <div className="form-group">
                                    <label>{LBL_END_DATE}</label>
                                    <div className="calendar-inputt doument-date">
                                    <DatePicker 
                                        selected={selectedEndDate}
                                        name="endDate"
                                        onChange={selected => this.onDateChange(2,selected)}  
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        dateFormat="dd/MM/yyyy"
                                        placeholderText={LBL_END_DATE}
                                        fixedHeight                                
                                        minDate={selectedStartDate}          
                                        />
                                    </div>  
                                </div>
                            </div>
                        </div>
                        }
                    </Form>
                  
                </ModalWindow>
                <ModalWindow ref={this.modalDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.onDeleteAction} resetModalForm={this.onModalFormReset}>
                    {LBL_CONFIRM_DELETE_DOCUMENT+" '"+this.state.docName+"'?"}
                </ModalWindow>
                <ModalWindow ref={this.modalFileDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.removeDocFileAction} resetModalForm={this.onModalFormReset}>
                    {LBL_CONFIRM_DELETE_FILE_FROM+" '"+this.state.docName+"'?"}
                </ModalWindow>
                <ModalWindow ref={this.modalPassportFileDelete} header={LBL_CONFIRM_DELETE} type="delete" deleteItem={this.removePassportFileAction} resetModalForm={this.onModalFormReset}>
                    {LBL_CONFIRM_DELETE_FILE_FROM+" Passport?"}
                </ModalWindow>
                <div className="row">&nbsp;</div>
                <div className="row">&nbsp;</div>
                <div className="row">&nbsp;</div>
                <div className="row">&nbsp;</div>
            </React.Fragment>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        docs:state.document.docItems,
        doc:state.document.item,
        docList:state.document.items,
        status:state.document.status,
        activity:state.document.activity, 
        errorData:state.document.errorData,
        docStatus:state.document.docStatus,
        serverTimeList: state.serverTimeList.serverTimeList,
        serverTimeListActivity : state.serverTimeList.serverTimeListActivity,
        passport_url: state.document.passport_url            
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        documentListAction:documentListAction,
        documentAddAction:documentAddAction,
        documentEditAction:documentEditAction,
        documentUpdateAction:documentUpdateAction,
        documentDeleteAction:documentDeleteAction,
        documentFileSaveAction:documentFileSaveAction,
        documentFileDeleteAction:documentFileDeleteAction,
        skillDocumentListAction:skillDocumentListAction,
        documentStatusUpdateAction:documentStatusUpdateAction,
        clearAction:clearAction,  
        serverTimeAction:serverTimeAction,
        passportFileSaveAction: passportFileSaveAction,
        visaFileSaveAction: visaFileSaveAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(DocumentsBkUp);
